'use strict'

export default class TypesenseError extends Error {}
